import { Component, Inject } from '@angular/core';

import { AlertController, Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from './app.config';
import { MyEvent } from 'src/services/myevent.services';
import { Constants } from 'src/models/contants.models';
import { Helper } from 'src/models/helper.models';
import { Router } from '@angular/router';
import { ShopService } from 'src/services/shop.services';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  rtlSide = 'left';
  selectedIndex: any;
  appPages: any;
  inactivityTimeoutMs = 30000;
  inactivityPromptTimeoutMs = 10000;
  inactivityTimer: any;
  inactivityPromptTimer: any;
  inactivityAlertOpen = false;

  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
    private platform: Platform,
    private navCtrl: NavController,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private alertController: AlertController,
    private translate: TranslateService,
    private router: Router,
    private myEvent: MyEvent,
    private shopService: ShopService
  ) {
    this.initializeApp();
    this.myEvent.getLanguageObservable().subscribe((value) => {
      // this.navCtrl.navigateRoot(['./']);
      this.globalize(value);
    });
  }

  initializeApp() {
    if (
      this.config.demoMode &&
      this.platform.is('cordova') &&
      !window.localStorage.getItem(Constants.KEY_IS_DEMO_MODE)
    ) {
      window.localStorage.setItem(Constants.KEY_IS_DEMO_MODE, 'true');
      this.language();
      //setTimeout(() => this.presentModal(), 30000);
    } else {
      //this.navCtrl.navigateRoot(['./']);
    }
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      let defaultLang = window.localStorage.getItem(
        Constants.KEY_DEFAULT_LANGUAGE
      );
      this.globalize(defaultLang);
      this.startInactivityWatcher();
      //this.darkModeSetting();
    });
  }

  startInactivityWatcher() {
    this.resetInactivityTimer();

    const activityEvents = ['click', 'touchstart', 'mousemove', 'keydown'];
    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (!this.inactivityAlertOpen) {
          this.resetInactivityTimer();
        }
      }, true);
    });
  }

  resetInactivityTimer() {
    if (!this.isInactivityReloadEnabled()) {
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      if (this.inactivityPromptTimer) {
        clearTimeout(this.inactivityPromptTimer);
      }
      return;
    }

    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }

    this.inactivityTimer = setTimeout(() => this.presentInactivityPrompt(), this.inactivityTimeoutMs);
  }

  async presentInactivityPrompt() {
    if (!this.isInactivityReloadEnabled()) {
      return;
    }

    if (this.inactivityAlertOpen) {
      return;
    }

    this.inactivityAlertOpen = true;

    const alert = await this.alertController.create({
      header: 'Nog aan het bestellen?',
      message: 'Druk op "Ja" om door te gaan. Zonder reactie wordt je bestelling geannuleerd.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ja',
          handler: () => {
            this.inactivityAlertOpen = false;
            if (this.inactivityPromptTimer) {
              clearTimeout(this.inactivityPromptTimer);
            }
            this.resetInactivityTimer();
          },
        },
      ],
    });

    await alert.present();

    this.inactivityPromptTimer = setTimeout(async () => {
      if (this.inactivityAlertOpen) {
        await alert.dismiss();
        this.inactivityAlertOpen = false;
        this.redirectToShop();
      }
    }, this.inactivityPromptTimeoutMs);
  }

  redirectToShop() {
    const shopId = this.shopService.getShopID();
    const redirectPath = shopId ? '/shop/' + shopId : '/shop';
    window.location.href =
      window.location.protocol + '//' + window.location.host + redirectPath;
  }

  isInactivityReloadEnabled() {
    return this.shopService.getShopID() === 9;
  }

  globalize(languagePriority) {
    this.translate.setDefaultLang('nl');
    let defaultLangCode = this.config.availableLanguages[0].code;
    this.translate.use(
      languagePriority && languagePriority.length
        ? languagePriority
        : defaultLangCode
    );
    this.setDirectionAccordingly(
      languagePriority && languagePriority.length
        ? languagePriority
        : defaultLangCode
    );
  }

  setDirectionAccordingly(lang: string) {
    switch (lang) {
      case 'ar': {
        this.rtlSide = 'rtl';
        break;
      }
      default: {
        this.rtlSide = 'ltr';
        break;
      }
    }
  }

  language(): void {
    this.navCtrl.navigateRoot(['./settings']);
  }

  darkModeSetting() {
    document.body.setAttribute(
      'class',
      Helper.getThemeMode(this.config.defaultThemeMode) ==
        Constants.THEME_MODE_DARK
        ? 'dark-theme'
        : 'light-theme'
    );
  }
}
